import React from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Component = styled.div`
    flex: 1;
    background-color: gray;
    background: rgb(9,104,121);
background: linear-gradient(126deg, rgba(9,104,121,1) 39%, rgba(6,97,166,1) 60%, rgba(0,83,251,0.49763655462184875) 100%);
    min-width: 300px;
    margin: 10px;
    border-radius: 10px;
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
                -10px -10px 30px rgba(9, 148, 255, 0.1), 
                inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    &:hover {
        background: rgb(9,25,121);
        background: linear-gradient(126deg, rgba(9,25,121,0.49763655462184875) 35%, rgba(0,212,255,0.49763655462184875) 100%);    
        }
`

const Card = styled.div`

    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px 5px;
    cursor: pointer;
    

`

const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 20px;
    
`

const PVDate = styled.p`
    flex: 1;
    padding: 0 20px;
`

const PVNumber = styled.p`
    flex: 1;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`
const Department = styled.h1`
    flex: 1;
    font-weight: 300;
    font-size: 20px;
    padding: 5px;
    margin: 0;
    text-align: center;
`

const Section = styled.h1`
    flex: 1;
    font-weight: 300;
    font-size: 20px;
    padding: 5px;
    margin: 0;
    text-align: center;
`

const Location = styled.h1`
    flex: 1;
    font-weight: 300;
    font-size: 20px;
    padding: 5px;
    margin: 0;
    text-align: center;
`

const Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const Payee = styled.h1`
    flex: 1;
    font-weight: 300;
    font-size: 20px;
    padding: 5px;
    margin: 0;
    text-align: center;
`

const TotalAmount = styled.span`
    flex: 1;
    padding: 10px;
    font-weight: bold;
    font-size: 20px;
`

const Body = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`

const ItemsContainer = styled.div`
    flex: 4;
    display: flex;
    align-items: center;
    flex-direction: column;
`
const Item = styled.span`
    flex: 1;
`

const StyledLink = styled(Link)`
    text-decoration: none;
    color: inherit;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
        color: inherit;
    }
`;



const VoucherCard = ({voucher : {voucherDateStr, voucherNo, dept, payee, totalAmount, itemDetails, section, location, paymode, bank, acctno, project}}) => {
    return (
        <Component>
            <StyledLink to={`/vouchers/${voucherNo}`} 
                        target="_blank"
                        title="Click to Open PV">
            <Card>
                
                <Header>
                    <PVDate>{voucherDateStr}</PVDate>
                    <PVNumber>{voucherNo}</PVNumber>
                </Header>
                <Body>
                    <Department>Dept: {dept}</Department>
                    <Section>Section: {section}</Section>
                    <Location>Location: {location}</Location>
                    <Location>Project: {project}</Location>
                    <Payee>Payee: {payee}</Payee>
                    <Payee>Payment Mode: {paymode}</Payee>
                    <Payee>Bank: {bank}</Payee>
                    <Payee>Account: {acctno}</Payee>
                    <ItemsContainer>
                        {itemDetails?.map((item, index) => (
                            <Item key={index}>{item.itemdesc} &#8358;{item.itemamount}</Item>
                        ))}
                    </ItemsContainer>

                </Body>
                <Footer>
                    <TotalAmount>&#x20A6;{totalAmount}</TotalAmount>
                </Footer> 
                
            </Card>
            </StyledLink>
        </Component>
    )
}

export default VoucherCard
